import * as actionTypes from "../ActionTypes";

// ✅ Church prayers
export const readChurchPrayersAction = (payload) => ({
  type: actionTypes.READ_CHURCH_PRAYERS_REQUEST,
  payload, // { data, callback }
});

// Channel prayers
export const readChannelPrayersAction = (payload) => ({
  type: actionTypes.READ_CHANNEL_PRAYERS_REQUEST,
  payload,
});

// Ministry prayers
export const readMinistryPrayersAction = (payload) => ({
  type: actionTypes.READ_MINISTRY_PRAYERS_REQUEST,
  payload,
});
